<template>
  <v-container tag="section" class="px-10 pb-10">
    <v-tabs v-model="tabs" hide-slider>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1" active-class="bg-primary white--text rounded-lg">
        <v-icon>mdi-account</v-icon>
        <span class="ml-4">Thông tin tài khoản</span>
      </v-tab>

      <v-tab href="#tab-2" active-class="bg-primary white--text rounded-lg">
        <v-icon>mdi-security</v-icon>
        <span class="ml-4">Bảo mật</span>
      </v-tab>
    </v-tabs>
    <v-row justify="end" class="pr-2">
      <v-col cols="12" sm="auto">
        <v-btn
          color="primary"
          x-large
          class="text-white"
          min-width="180"
          width="100%"
          button
          dark
          @click="addElevatorForUser"
        >
          <v-icon right dark class="mr-2"> mdi-plus-box </v-icon>
          Thêm thang
        </v-btn>
      </v-col>
    </v-row>

    <v-tabs-items v-model="tabs">
      <v-tab-item value="tab-1">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-skeleton-loader
            ref="skeleton_heading"
            :loading="isLoading"
            transition="scale-transition"
            :boilerplate="false"
            :types="{ skeleton: 'table' }"
            type="skeleton"
            class="mx-auto"
          >
            <div class="mt-8">
              <p class="text-xl font-medium">1. Thông tin chung</p>
              <v-row class="mt-0">
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="phone"
                    :rules="[rules.required]"
                    @keypress="filter(event)"
                    outlined
                    prepend-inner-icon="mdi-phone"
                    color="#FBB040"
                    label="Số điện thoại*"
                    :maxLength="10"
                    :hide-details="isMobile"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="email"
                    :rules="[rules.email]"
                    outlined
                    prepend-inner-icon="mdi-email"
                    color="#FBB040"
                    label="Email"
                    :hide-details="isMobile"
                  />
                </v-col>
              </v-row>

              <v-row class="mt-0">
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="modelName"
                    :rules="[rules.required]"
                    outlined
                    prepend-inner-icon="mdi-face-man"
                    color="#FBB040"
                    label="Họ và tên*"
                    :hide-details="isMobile"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <BirthdayPicker v-model="dateOfBirth" />
                </v-col>
                <v-col>
                  <v-radio-group v-model="modelGender" row>
                    <v-radio label="Nam" :value="1" color="#FBB040" />
                    <v-radio label="Nữ" :value="2" color="#FBB040" />
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row class="mt-0">
                <v-col cols="12" sm="3">
                  <v-select
                    v-model="roleId"
                    :items="roleList"
                    prepend-inner-icon="mdi-roller-shade"
                    no-data-text="Không có dữ liệu"
                    item-text="name"
                    item-value="id"
                    :rules="[rules.required]"
                    outlined
                    color="#FBB040"
                    label="Chức vụ*"
                    :hide-details="isMobile"
                  /> </v-col
              ></v-row>
              <v-row class="mt-0">
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="modelAddress"
                    outlined
                    :rules="[rules.required]"
                    prepend-inner-icon="mdi-home-city-outline"
                    color="#FBB040"
                    label="Địa chỉ*"
                  />
                </v-col>
              </v-row>
              <v-row class="mt-0">
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="googleMapURL"
                    outlined
                    prepend-inner-icon="mdi-map-marker-check"
                    color="#FBB040"
                    label="Bản đồ"
                  />
                </v-col>
              </v-row>
              <v-row class="mb-3" v-if="googleMapURLParam">
                <iframe
                  :src="googleMapURLParam"
                  width="600"
                  height="450"
                  style="border: 0; margin-left: 0px; padding-left: 15pxx"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </v-row>
              <p class="text-xl font-medium mt-4">2. Thông tin bổ sung</p>
              <v-expansion-panels multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>Thêm thông tin</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mt-0">
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="modelFacebook"
                          outlined
                          color="#FBB040"
                          prepend-inner-icon="mdi-facebook"
                          label="Facebook"
                          :hide-details="isMobile"
                        />
                      </v-col>
                    </v-row>

                    <v-row class="mt-0">
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="modelZalo"
                          outlined
                          color="#FBB040"
                          prepend-inner-icon="mdi-alpha-z-circle-outline"
                          label="Zalo"
                          :hide-details="isMobile"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="modelNote"
                          outlined
                          prepend-inner-icon="mdi-notebook"
                          color="#FBB040"
                          label="Ghi chú"
                          :hide-details="isMobile"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-row class="mt-4">
                <v-col cols="3" sm="3">
                  <v-switch
                    v-model="isActive"
                    v-if="role == 'Admin'"
                    label="Sử dụng"
                    class="m-0"
                    color="#FBB040"
                    hide-details="false"
                  />
                </v-col>
              </v-row>
              <v-row class="mt-8 ml-1">
                <p class="ml-2">Phần này chỉ thiết lập cho nhân viên</p>
              </v-row>
              <v-row class="mt-4">
                <v-col cols="3" sm="3">
                  <v-switch
                    v-model="isReceiveNotification"
                    v-if="role == 'Admin'"
                    label="Nhận thông báo app"
                    class="m-0"
                    color="#FBB040"
                    hide-details="false"
                  />
                </v-col>
                <v-col cols="3" sm="3">
                  <v-switch
                    v-model="isReceiveZalo"
                    v-if="role == 'Admin'"
                    label="Nhận thông báo zalo"
                    class="m-0"
                    color="#FBB040"
                    hide-details="false"
                  />
                </v-col>
              </v-row>
              <v-row class="mt-5">
                <v-col cols="3" sm="3">
                  <v-text-field
                    v-if="role == 'Admin'"
                    outlined
                    disabled
                    v-model="createdAt"
                    prepend-inner-icon="mdi-timer-cog-outline"
                    color="#FBB040"
                    label="Khởi tạo"
                  />
                </v-col>
                <v-col cols="3" sm="3">
                  <v-text-field
                    v-if="role == 'Admin'"
                    outlined
                    disabled
                    v-model="updatedAt"
                    prepend-inner-icon="mdi-timer"
                    color="#FBB040"
                    label="Cập nhật"
                  /> </v-col
              ></v-row>
              <v-row class="mt-4">
                <v-col cols="12" sm="6">
                  <v-btn
                    x-large
                    color="#FBB040"
                    class="text-white"
                    button
                    dark
                    @click="onUpdateProfile"
                  >
                    <v-icon right dark class="mr-2"> mdi-folder-plus </v-icon>
                    Cập nhật
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-skeleton-loader>
        </v-form>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-form ref="formPassword" v-model="validPassword" lazy-validation>
          <div class="mt-8 ml-4">
            <p class="text-xl font-medium">Đặt lại mật khẩu</p>
            <v-row class="mt-0">
              <v-col cols="12" sm="3">
                <v-text-field
                  :value="password"
                  prepend-inner-icon="mdi-content-copy"
                  append-icon="mdi-restart"
                  outlined
                  :hide-details="isMobile"
                  :rules="[rules.required]"
                  color="black"
                  readonly
                  class="centered-text"
                  @click:append="onGeneratePassword"
                  @click:prepend-inner="onCopy"
                />
              </v-col>
            </v-row>
            <v-row class="mt-4">
              <v-col cols="12" sm="6">
                <v-btn
                  x-large
                  color="#FBB040"
                  class="text-white"
                  button
                  dark
                  @click="onUpdatePassword"
                >
                  <v-icon right dark class="mr-2"> mdi-folder-plus </v-icon>
                  Cập nhật
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import BirthdayPicker from "~/components/atoms/BirthdayPicker";
import { mapState } from "vuex";
import { EMPTY } from "~/utils/constants";
import { required, email } from "~/utils/validation";
import { randomNumber } from "~/utils";

const UPPER_CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const NORMAL_CHARACTERS = "abcdefghijklmnopqrstuvwxyz";
const NUMBER_CHARACTERS = "0123456789";
const SPECIAL_CHARACTERS = "!@#$%^&*";

export default {
  name: "UserDetail",
  components: { BirthdayPicker },
  data() {
    return {
      password: EMPTY,
      tabs: null,
      gender: 1,
      rules: {
        required,
        email,
      },
      phone: EMPTY,
      email: null,
      modelName: null,
      dateOfBirth: EMPTY,
      gender: 1,
      provinceId: null,
      districtId: null,
      wardId: null,
      address: null,
      modelEthnic: null,
      modelNationality: null,
      modeIdentityCard: EMPTY,
      modelFacebook: EMPTY,
      modelZalo: EMPTY,
      modelNote: EMPTY,
      googleMapURL: null,
      googleMapURLParam: null,
      districtList: [],
      wardList: [],
      valid: true,
      validPassword: true,
      modelAddress: null,
      isLoading: false,
      isLoading: false,
      isDeleted: false,
      isActive: true,
      createdAt: EMPTY,
      updatedAt: EMPTY,
      modelGender: 1,
      evt: null,
      elevatorList: [],
      roleList: [],
      isReceiveNotification: false,
      isReceiveZalo: false,
    };
  },
  async created() {
    await this.getListMasterRole();
    this.getElevatorBelongUser();
    this.isLoading = true;
    const { userId } = this.$route.params;
    const data = await this.$services.userService.getUserDetail(userId);
    if (
      data &&
      Object.keys(data).length !== 0 &&
      Object.getPrototypeOf(data) === Object.prototype
    ) {
      this.email = data?.email;
      this.phone = data?.phone;
      this.modelName = data?.name;
      this.roleId = Number(data?.roleId);
      this.modelAddress = data?.address;
      this.dateOfBirth = data?.dateOfBirth;
      this.modelGender = data?.gender;
      this.modelFacebook = data?.facebookUrl;
      this.modelZalo = data?.zaloUrl;
      this.modelNote = data?.description;
      this.isDeleted = data?.isDeleted;
      this.isActive = data?.isActive;
      this.createdAt = data?.createdAt;
      this.updatedAt = data?.updatedAt;
      this.googleMapURL = data?.googleMapEmbbed;
      this.googleMapURLParam = data?.googleMapEmbbed;
      this.isLoading = false;
      this.isReceiveNotification = data?.isReceiveNotification;
      this.isReceiveZalo = data?.isReceiveZalo;
    }
  },
  computed: {
    ...mapState(["provinceList", "ethnicList", "measureList", "additionalInfoList"]),
    ...mapState({
      role: (state) => state.user.roleName,
    }),
    isMobile() {
      return window.innerWidth <= 640;
    },
  },
  methods: {
    async getListMasterRole() {
      try {
        const data = await this.$services.commonService.getListMasterRole();
        this.roleList = data;
      } catch (err) {
      } finally {
      }
    },
    async getElevatorBelongUser() {
      this.isLoading = true;
      try {
        const { userId } = this.$route.params;
        const data = await this.$services.elevatorService.getElevatorBelongUser(userId);
        this.elevatorList = data;
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    addElevatorForUser() {
      const { userId } = this.$route.params;
      this.$router.push({
        name: "CreateElevatorUser",
        params: { userId },
      });
    },
    assignObject(resource, destination) {
      Object.keys(resource).forEach((key) => {
        if (destination[key] !== undefined) {
          destination[key] = resource[key];
        }
      });
    },
    filter(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async onUpdateProfile() {
      this.$modal.show({
        title: "Xác nhận cập nhật thông tin cho tài khoản này?",
        visible: true,
        callbackConfirm: async () => this.updateUserInformation(),
      });
    },
    async updateUserInformation() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.isLoadingActions = true;
        try {
          const { userId } = this.$route.params;
          await this.$services.commonService.updateUserProfileAdmin(userId, {
            phone: this.phone,
            name: this.modelName,
            email: this.email,
            phone: this.phone,
            roleId: this.roleId,
            address: this.modelAddress,
            dateOfBirth: this.dateOfBirth,
            gender: this.modelGender,
            facebookUrl: this.modelFacebook,
            isActive: this.isActive,
            zaloUrl: this.modelZalo,
            description: this.modelNote,
            googleMapURL: this.googleMapURL,
            isReceiveNotification: this.isReceiveNotification,
            isReceiveZalo: this.isReceiveZalo,
          });
        } catch (err) {
          console.log(err);
        } finally {
          this.isLoadingActions = false;
          this.$router.push({ name: "UserList" });
        }
      }
    },
    async onUpdatePassword() {
      await this.$refs.formPassword.validate();
      if (this.validPassword) {
        this.$modal.show({
          title: "Xác nhận đặt lại mật khẩu cho tài khoản này?",
          visible: true,
          callbackConfirm: async () => this.adminUpdatePassword(),
        });
      }
    },
    async adminUpdatePassword() {
      this.isLoadingActions = true;
      const { userId } = this.$route.params;
      try {
        await this.$services.userService.updateUserPasswordAdmin(userId, {
          password: this.password,
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoadingActions = false;
      }
    },
    onGeneratePassword() {
      this.password = EMPTY;
      const upperCharacter = UPPER_CHARACTERS.charAt(
        randomNumber(UPPER_CHARACTERS.length)
      );
      this.password += upperCharacter;
      for (let i = 0; i < 2; i++) {
        const normalCharacter = NORMAL_CHARACTERS.charAt(
          randomNumber(NORMAL_CHARACTERS.length)
        );
        this.password += normalCharacter;
      }
      for (let i = 0; i < 3; i++) {
        const numberCharacter = NUMBER_CHARACTERS.charAt(
          randomNumber(NUMBER_CHARACTERS.length)
        );
        this.password += numberCharacter;
      }
      const specialCharacter = SPECIAL_CHARACTERS.charAt(
        randomNumber(SPECIAL_CHARACTERS.length)
      );
      this.password += specialCharacter;
    },
    onCopy() {
      this.$copyText(this.password)
        .then(() => {
          this.$toasted.success("Sao chép mật khẩu thành công").goAway(1000);
        })
        .catch(() => {
          this.$toasted.error("Mật khẩu không hợp lệ").goAway(1000);
        });
    },
  },
};
</script>
